import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import BigPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/BigPicklistControl';

const AssetsAndLiabilitiesPartnerQuestionMetaOverride = buildFacetDesignOverride()
  .nameOverride('answer', {
    _component: () => BigPicklistControl,
    _customProps: {
      multiple: false,
      testName: 'qualitative-question',
    },
    _customHelperProps: {
      showRequiredHelperText: false,
    },
  }, overrideReadOnly);

export { AssetsAndLiabilitiesPartnerQuestionMetaOverride };
